<section class="mt-3 text-center w-100">
    <p class="fw-medium m-0">Click the + button to add a pause period.</p>
    <p>You can add one or more date ranges to skip your deliveries during those times.</p>
</section>

<section class="m-auto" [class.w-75]="!isMobile()" [class.w-100]="isMobile()">
    <app-empty-message [message]="nextDeliveryMessage" [showIcon]="false"></app-empty-message>
</section>

<div class="d-flex flex-column gap-2 m-auto" [class.w-75]="!isMobile()" [class.w-100]="isMobile()">
    <section class="d-flex gap-2">
        <mat-form-field class="w-100 mb-0">
            <mat-label>Choose a pause period</mat-label>
            <mat-date-range-input [dateFilter]="dateFilter" [min]="minDate()" #calendar [formGroup]="range"
                [rangePicker]="picker">
                <input matStartDate readonly formControlName="start" placeholder="Start date">
                <input matEndDate readonly formControlName="end" placeholder="End date">
            </mat-date-range-input>
            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker">
                <mat-icon matDatepickerToggleIcon>add</mat-icon>
            </mat-datepicker-toggle>
            <mat-date-range-picker [touchUi]="isMobile()" [dateClass]="isSelected" [startAt]="firstEnableDate()"
                #picker></mat-date-range-picker>
        </mat-form-field>
    </section>

    <hr>

    @if(selectedRanges().length){
    <table class="table table-borderless table-striped w-100 table-responsive">
        <thead>
            <tr>
                <th>#</th>
                <th>Starts</th>
                <th>Ends</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            @for (item of selectedRanges(); track $index) {
            <tr>
                <th>{{$index + 1}}</th>
                <td>{{item.start}}</td>
                <td>{{item.end}}</td>
                <td>
                    <i class="fas fa-trash text-primary cursor-pointer" (click)="removeDateRange($index)"></i>
                </td>
            </tr>
            }
        </tbody>
    </table>
    } @else {
    <app-empty-message [width100]="true"
        [message]="'No date range selected yet. Please add at least one to continue.'"></app-empty-message>
    }

</div>

<div class="row mt-5 animated fadeIn justify-content-center">
    <div class="col-6 col-lg-4 col-md-6">
        <button type="button" class="btn w-100 btn-outline-primary" (click)="activeModal.close()">Cancel</button>
    </div>
    <div class="col-6 col-lg-4 col-md-6">
        <button type="button" class="btn w-100 btn-primary" (click)="validatePauseDate()">
            {{ isEditMode() ? !selectedRanges().length ? 'Remove all Pauses' : 'Update Pause' : 'Pause Subscriptions' }}
        </button>
    </div>
</div>